import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'third/jquery.slick';

const fragments = {
    NAVIGATION_ITEM: '[data-fragment="ColorDescriptionModal.navigationItem"]',
    CONTENT_ITEM: '[data-fragment="ColorDescriptionModal.contentItem"]',
    CONFIGURATOR_COLOR_CONFIG_ITEM: '[data-fragment="Configurator.color.config.item"]',
    CONFIGURATOR_COLOR_CONFIG_ITEM_BUTTON: '[data-fragment="Configurator.color.config.item.button"]',
};

class ColorDescriptionModal extends WebComponent {

    didMount() {
        const self = this;
        this.navigationItems = this.element.querySelectorAll(fragments.NAVIGATION_ITEM);
        this.contentItems = this.element.querySelectorAll(fragments.CONTENT_ITEM);
        this.configuratorColorConfigItem = document.querySelectorAll(fragments.CONFIGURATOR_COLOR_CONFIG_ITEM);

        this.navigationItems.forEach(function(navigationItem, i) {
            navigationItem.addEventListener('click', function(e) {
                self.navigationItems.forEach(function(navigationItem){
                    navigationItem.classList.remove('color-description__navigation-item--active');
                });
                self.contentItems.forEach(function(contentItem){
                    contentItem.classList.remove('color-description__content-item--active');
                });
                self.navigationItems[i].classList.add('color-description__navigation-item--active');
                self.contentItems[i].classList.add('color-description__content-item--active');
                $(self.contentItems[i]).find('.slick-slider').slick('setPosition'); // reinitialise slider
            });
        });

        // Podpora pro konfigurátor
        if (this.configuratorColorConfigItem.length !== 0) {
            this.configuratorColorConfigItem.forEach(function(item) {
                if (item.classList.contains('controls-variant__item--active')) {
                    const code = item.querySelector(fragments.CONFIGURATOR_COLOR_CONFIG_ITEM_BUTTON).dataset.code;
                    self.navigationItems.forEach(function(navigationItem, i) {
                        if (navigationItem.dataset.code === code) navigationItem.click();
                    });
                }
            });
        }
    }
}

export default ColorDescriptionModal;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ColorDescriptionModal.js